import { defineMessages } from 'react-intl'

export default defineMessages({
  'components.PhoneInput.picker.label': {
    id: 'components.PhoneInput.picker.label',
    defaultMessage: '国家/地区',
    description: '选择国家/地区列表的label'
  },
  'components.PhoneInput.picker.title': {
    id: 'components.PhoneInput.picker.title',
    defaultMessage: 'Choose Country Calling Number',
    description: '选择国家/地区列表的title'
  },
  'components.PhoneInput.input.label': {
    id: 'components.PhoneInput.input.label',
    defaultMessage: '手机号码',
    description: '手机号码输入框的label'
  },
  'components.PhoneInput.input.placeholder': {
    id: 'components.PhoneInput.input.placeholder',
    defaultMessage: 'Mobile Phone Number',
    description: '手机号码输入框的placeholder'
  },
})
